// The browser's built-in PDF viewer (Chrome/Edge) reads PDF Open Parameters
// off the URL fragment - safe to append after a presigned S3 URL's query
// string since fragments never get sent to the server. Used to control the
// initial view without any extra dependency.

// Uploaded PDF attachments, in the modal's single-page zoomed view: start
// a bit more zoomed in than the viewer's own default, so the page is
// readable without the user having to click the zoom-in control themselves.
export function toZoomedPdfUrl(url: string): string {
  return `${url}#zoom=100`;
}

// Chart screenshots (main + zoomed-in) are wide/landscape but exported onto
// a tall page with a lot of blank space below the chart. Fit-to-width keeps
// the whole chart visible with no side-to-side cropping regardless of
// exactly how tall that blank area is, instead of guessing a zoom percent.
export function toZoomedChartUrl(url: string): string {
  return `${url}#view=FitH`;
}

// Fit-to-width for the chart-screenshot thumbnail cards and the per-document
// page grid (inside the "view all pages" modal), so the whole page width
// shows instead of just its top-left corner at the viewer's default zoom.
// Toolbar hidden since nothing here is interactive.
export function toFitWidthThumbnailUrl(url: string): string {
  return `${url}#view=FitH&toolbar=0`;
}

// The single first-page icon representing an uploaded PDF on the main report
// page. Same fit-to-width technique as toFitWidthThumbnailUrl, but kept as
// its own named setting so it can be tuned independently from the
// per-document page grid without changing that one too.
export function toPdfCardThumbnailUrl(url: string): string {
  return `${url}#view=FitH&toolbar=0`;
}
